import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import InfiniteScroll from 'react-infinite-scroller';
import _ from 'lodash';
import * as styles from './ImagePicker.scss';

var ImagePickerPixabay = /*#__PURE__*/function (_Component) {
  _inherits(ImagePickerPixabay, _Component);

  var _super = _createSuper(ImagePickerPixabay);

  function ImagePickerPixabay(props) {
    var _this;

    _classCallCheck(this, ImagePickerPixabay);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_searchImages", function (nextPage) {
      var _this$state = _this.state,
          searchUrl = _this$state.searchUrl,
          searchValue = _this$state.searchValue,
          page = _this$state.page,
          loading = _this$state.loading;

      if (searchValue.length < 1) {
        return;
      }

      if (loading) {
        return;
      }

      var url = "".concat(searchUrl, "&q=").concat(searchValue.replace(' ', '+'));

      if (nextPage) {
        url += "&page=".concat(nextPage);
      }

      _this.setState({
        loading: true
      });

      fetch(url, {
        method: 'get'
      }).then(function (res) {
        return res.json();
      }).then(function (response) {
        var images = response.hits;
        var hasMore = true;
        var total = response.total,
            totalHits = response.totalHits;

        if (totalHits <= page * 20) {
          hasMore = false;
        }

        _this.setState({
          images: _this.state.images.concat(images),
          page: nextPage || 1,
          loading: false,
          hasMore: hasMore
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchChange", function (event) {
      var value = event.target.value;
      event.stopPropagation();

      _this.setState({
        searchValue: value,
        page: 1,
        images: []
      });

      if (value) {
        _this.searchImages();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();

        _this.reset();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      _this.setState({
        searchValue: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      var _this$state2 = _this.state,
          searchValue = _this$state2.searchValue,
          page = _this$state2.page;
      var nextPage = parseInt(page) + 1;

      if (searchValue) {
        _this.searchImages(nextPage);
      }
    });

    var key = '13292995-e70ed88611ab433d88f8f56bc';
    _this.state = {
      images: [],
      searchValue: '',
      loading: false,
      hasMore: true,
      searchUrl: "https://pixabay.com/api/?key=".concat(key, "&image_type=photo&safesearch=true"),
      page: 1
    }; // pre-populate images for better looking UI

    fetch("https://pixabay.com/api/?key=".concat(key, "&image_type=photo&safesearch=true&q="), {
      method: 'get'
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      var images = response.hits;

      _this.setState({
        images: _this.state.images.concat(images)
      });
    });
    _this.searchImages = _.debounce(_this._searchImages, 500);
    return _this;
  }

  _createClass(ImagePickerPixabay, [{
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          images = _this$state3.images,
          loading = _this$state3.loading,
          hasMore = _this$state3.hasMore;
      var _this$props = this.props,
          handleSelectImage = _this$props.handleSelectImage,
          selectedImages = _this$props.selectedImages;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.pixabayWrapper,
        style: images.length ? {
          height: 400
        } : {
          height: 100
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        value: this.state.searchValue,
        onChange: this.onSearchChange,
        onKeyDown: this.onKeyDown,
        defaultValue: "Search Images...",
        fixedFloatingLabel: true,
        floatingLabelText: "Search Stock Images",
        style: {
          marginLeft: 214
        }
      }), !!images.length && /*#__PURE__*/React.createElement("div", {
        className: styles.pixabayContentWrap
      }, /*#__PURE__*/React.createElement(InfiniteScroll, {
        loadMore: this.loadMore,
        hasMore: !loading && hasMore,
        initialLoad: false,
        useWindow: false,
        threshold: 700,
        style: {
          borderTop: '1px solid rgb(224, 224, 224)'
        }
      }, images.map(function (image, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "image_".concat(index),
          className: "".concat(styles.pixabayImage, " ").concat(_.some(selectedImages, image) ? styles.selectedPixabayImage : ''),
          style: {
            backgroundImage: "url(".concat(image.previewURL, ")")
          },
          onClick: function onClick() {
            handleSelectImage(image);
          }
        });
      })))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          fontSize: 13,
          color: '#333333',
          margin: 8,
          padding: '4px 8px 2px'
        }
      }, "POWERED BY", /*#__PURE__*/React.createElement("a", {
        href: "https://pixabay.com/",
        target: "_blank",
        rel: "noopener"
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          height: 32,
          marginLeft: 8
        },
        src: "https://s3.amazonaws.com/likeabucket/user_upload/216/E4N9_ORlK.png"
      }))));
    }
  }]);

  return ImagePickerPixabay;
}(Component);

export { ImagePickerPixabay as default };
ImagePickerPixabay.defaultProps = {
  placeholder: 'Search for images',
  imagePlaceholderColor: '#000000',
  loader: /*#__PURE__*/React.createElement("p", null, "Loading...")
};